import React, { useLayoutEffect, useState } from 'react';
import { TablePaginationConfig } from 'antd';
import { SkyPaginationTotal } from './SkyPagination';
import { appConfig } from '../../settings';
import { usePagesStoreCurrentComponent } from '../../hooks';
import { getDefaultPageParams, setUiPageSize } from '../../middleware';
import { FilterPageSize } from '../FilterToolbar/Components';
import Styles from './m_styles.less';

type ISkyTablePaginationProps = {
    total?: number;
};

export const useSkyTablePagination = ({ total = 0 }: ISkyTablePaginationProps): false | TablePaginationConfig => {
    const { routeName } = usePagesStoreCurrentComponent();
    const [pageSize, setPageSize] = useState(appConfig.pageDefaultParams.includeViewPageSize);
    const pageSizeOptions = appConfig.pageDefaultParams.pageSizeValues.map((i: number) => i.toString());

    useLayoutEffect(() => {
        const { pageSize } = getDefaultPageParams(routeName);
        if (pageSize) {
            setPageSize(pageSize);
            setUiPageSize(pageSize);
        }
    }, []);

    const onShowSizeChange = (_: number, size: number): void => {
        setPageSize(size);
    };
    const onChangePageSize = (n?: number) => {
        n && setPageSize(n);
    };

    const showTotal = (total: number, range: Array<number>): React.ReactNode => {
        return (
            <div className={Styles.skyTablePaginationTotal}>
                <FilterPageSize onChange={onChangePageSize} isSelectOnly />
                {SkyPaginationTotal(total, range)}
            </div>
        );
    };

    return pageSize > total
        ? false
        : {
              position: ['bottomLeft'],
              pageSizeOptions,
              pageSize,
              onShowSizeChange,
              showTotal,
              showSizeChanger: false,
          };
};
